/**
 *
 * ParrotSoftware
 * SettingsTablesConfigProvider root
 *
 */
import { Children, memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function TablesConfig({ children }) {
  useInjectSaga({ key: 'settingsTablesConfig', saga });
  useInjectReducer({ key: 'settingsTablesConfig', reducer });

  return Children.only(children);
}

TablesConfig.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withSettingsTablesConfig } from './withSettingsTablesConfig';
export default compose(withConnect, memo)(TablesConfig);
